module.exports = __webpack_public_path__ + "static/media/20210403_201439_778_IMG_0028.b9e09db2.jpg";